import React, { useState, useEffect, Fragment } from 'react';
import { ReactComponent as CallIcon } from './icons/call.svg';
import { ReactComponent as CallOffIcon } from './icons/callOff.svg';
import { ReactComponent as CallBackIcon } from './icons/callBack.svg';
import { ReactComponent as CallDisabledIcon } from './icons/callDisabled.svg';
import { ReactComponent as HangIcon } from './icons/hang.svg';
import { ReactComponent as HangDisabledIcon } from './icons/hangDisabled.svg';
import { ReactComponent as MuteIcon } from './icons/mute.svg';
import { ReactComponent as MuteDisabledIcon } from './icons/muteDisabled.svg';
import { ReactComponent as UnmuteIcon } from './icons/unmute.svg';
import { ReactComponent as HoldIcon } from './icons/hold.svg';
import { ReactComponent as HoldDisabledIcon } from './icons/holdDisabled.svg';
import { ReactComponent as UnholdIcon } from './icons/unhold.svg';
import { ReactComponent as RecordEnabledIcon } from './icons/recordEnabled.svg';
import { ReactComponent as RecordDisabledIcon } from './icons/recordDisabled.svg';
import { ReactComponent as RecordActiveIcon } from './icons/recordActive.svg';

import { ReactComponent as CallExecutive } from './icons/callExecutive.svg';
import { ReactComponent as HangExecutive } from './icons/hangExecutive.svg'; 

import { ReactComponent as TransferIcon } from './icons/transfer.svg';
import { ReactComponent as Edge } from './icons/softphoneSidebar.svg';
import { InfoIcon, ExternalCallIcon } from './icons/svgIcons';
import AudioRecording from './AudioRecording';
import Tools from './Tools';
import { useSoftphone } from './SoftphoneContext.jsx';
import Popover from './ui/Popover';

const SoftphonePanel = (props) => {

    const [callExtraHeaders, setCallExtraHeaders] = useState(null);
    const [executiveCallExtraHeaders, setExecutiveCallExtraHeaders] = useState(null);
    const [currentCampaigType, setCurrentCampaigType] = useState(null);
    const [localInboundConnectedQueues, SetLocalInboundConnectedQueues] = useState(null);
    const [recording, setRecording] = useState(false);
    const [popupInfoCallVisible, setPopupInfoCallVisible] = useState(false);
    const [popupExternalCallVisible, setPopupExternalCallVisible] = useState(false);

    const { softphoneSessionDirection, outgoingCallStatus, incomingCallStatus, callClient, 
            hangUpAllCalls, hangUpClient, answerIncomingCall, rejectIncomingCall, mute, unmute, hold, unhold, 
            muted, holded, callExecutive, hangUpExecutive, transferClientCallToExecutive, executiveCallStatus, softphoneConnectionStatus, unregister } = useSoftphone();

    useEffect(() => {
        if(props.selectedCampaign){
            setCurrentCampaigType(props.selectedCampaign.type);
            setCallExtraHeaders([`cedente:${props.selectedCampaign.company_info.code}`, `iditem:${(props.currentClient).replaceAll('-', '')}`, `idcampaign:${props.selectedCampaign._id}`, `target:client`, `callPrefix:${props.selectedCampaign.callPrefix??'600'}`]);
            setExecutiveCallExtraHeaders([`cedente:${props.selectedCampaign.company_info.code}`, `iditem:${(props.currentClient).replaceAll('-', '')}`, `idcampaign:${props.selectedCampaign._id}`, `target:executive`]);
        }
    }, [props.selectedCampaign]);


    useEffect(() => {
        //SI REFRESCA OBTIENE LISTADO DE COLAS INBOUND DESDE SESIONSTORAGE 
        if(props.inboundConnectedQueues.length===0){
            if(sessionStorage.getItem("connectedInboundQueues")){
                SetLocalInboundConnectedQueues(JSON.parse(sessionStorage.getItem("connectedInboundQueues")));
            }
        } else {
            SetLocalInboundConnectedQueues(props.inboundConnectedQueues);
        }
    }, [props.inboundConnectedQueues]);


    
    useEffect(() => {
        if (
            (softphoneSessionDirection === 'none' && 
            (incomingCallStatus === 'ended' || incomingCallStatus === 'none')) && 
            (outgoingCallStatus === 'ended' || outgoingCallStatus === 'none')){
            
            //si finaliza la llamada y usuario NO detiene grabación
            //automaticamente deja el estado en falso  
            if(recording){
                setRecording(false);
                //se supone que asterisk corta la grabación cuando se detiene llamada
                //asi que no debería volver a digitar *3
            }
        }
    }, [incomingCallStatus, outgoingCallStatus]);


    return (
        <div className="softphonePanel">  

            <div className="edgeTop"><Edge/></div>
            <div className="callContainer">

                {softphoneSessionDirection === 'incoming' ? ( //INCOMING <<<== (ENTRANTE) 
                    <Fragment>
                        {incomingCallStatus === 'progress' ? (
                            <Fragment>
                                <a tooltip="contestar" onClick={() => answerIncomingCall()}><CallIcon /></a>
                                <a tooltip="Cortar" onClick={() => rejectIncomingCall()} ><HangIcon /></a>
                                <MuteDisabledIcon />
                                <HoldDisabledIcon />
                            </Fragment>
                        ): incomingCallStatus === 'confirmed' ? (
                            <Fragment>
                                <a className='withoutCursor'><CallDisabledIcon /></a>
                                    <a tooltip="Colgar" onClick={() => hangUpAllCalls()} ><HangIcon /></a>
                                {muted ? (
                                    <a tooltip="desmutear" onClick={() => unmute('client')} ><UnmuteIcon /></a>
                                ) : (
                                    <a tooltip="mutear" onClick={() => mute('client')} ><MuteIcon /></a>
                                )}

                                {holded ? (
                                    <a tooltip="Salir de llamada en espera" onClick={() => unhold('client')} ><UnholdIcon /></a>
                                ) : (
                                    <a tooltip="Llamada en espera" onClick={() => hold('client')} ><HoldIcon /></a>
                                )}
                            </Fragment>
                        ) : incomingCallStatus === 'ended' ? (
                            <Fragment>
                                    <a className='withoutCursor'><CallDisabledIcon /></a>
                                    <HangDisabledIcon />
                                    <MuteDisabledIcon />
                                    <HoldDisabledIcon />
                                    {/* <p>ENDED</p> */}
                            </Fragment>
                        ) : incomingCallStatus === 'none' ? (
                                <p>&nbsp;</p>
                        ) : 
                        
                        <Fragment>
                            <a className='withoutCursor'><CallDisabledIcon /></a>
                            <HangDisabledIcon />
                            <MuteDisabledIcon />
                            <HoldDisabledIcon />
                            {/* <p>NULL</p> */}
                        </Fragment>
                        }
                    </Fragment>
                ): //OUTGOING ==>>> (SALIDA) 
                    outgoingCallStatus === 'confirmed' ? (
                        <Fragment>
                        <a className='withoutCursor'><CallOffIcon /></a>    
                        <a tooltip="colgar/cortar" onClick={() => hangUpClient()} ><HangIcon /></a>
                        {muted ? (
                            <a tooltip="desmutear" onClick={() => unmute('client')} ><UnmuteIcon /></a>
                        ) : (
                            <a tooltip="mutear" onClick={() => mute('client')} ><MuteIcon /></a>
                        )}

                        {holded ? (
                            <a tooltip="Salir de llamada en espera" onClick={() => unhold('client')} ><UnholdIcon /></a>
                        ) : (
                            <a tooltip="Llamada en espera" onClick={() => hold('client')} ><HoldIcon /></a>
                        )}

                        </Fragment>
                    ):
                        outgoingCallStatus === 'peerconnection' || outgoingCallStatus === 'progress' ?
                    (
                        <Fragment>
                            <a className='withoutCursor'><CallOffIcon /></a>
                            <a tooltip="cortar llamada saliente" onClick={() => hangUpAllCalls()} ><HangIcon /></a>
                            <MuteDisabledIcon />
                            <HoldDisabledIcon />
                        </Fragment>
                    ):(
                        <Fragment>
                            {props.currentClient && currentCampaigType==='ASSISTED'?(
                                <a tooltip="llamar al cliente" className='callIcon' onClick={() => callClient(props.currentPhone, callExtraHeaders)}><CallOffIcon /></a> 
                            ) : props.currentClient && props.currentPhone !=='SIN TELEFONO' && currentCampaigType === 'GENERIC_INBOUND' ? (
                                <a tooltip="llamar de vuelta" className='callIcon' onClick={() => callClient(props.currentPhone, callExtraHeaders)}><CallBackIcon /></a>
                            ) : (<CallDisabledIcon />)}
                            <HangDisabledIcon />
                            <MuteDisabledIcon />
                            <HoldDisabledIcon />

                        </Fragment>
                    )
                }

                {(incomingCallStatus === 'confirmed' || outgoingCallStatus === 'confirmed') && !recording ? (
                    <a tooltip="Iniciar grabación" onClick={() => { setRecording(true); AudioRecording.record('start', props.currentPhone); props.setLastRecordingData({ campaignId: props.selectedCampaign._id, clientId: props.currentClient }) }}><RecordEnabledIcon/></a>
                ) : (incomingCallStatus === 'confirmed' || outgoingCallStatus === 'confirmed') && recording ? (
                    <a tooltip="Detener grabación" onClick={() => { setRecording(false); AudioRecording.record('stop', props.currentPhone);}}><RecordActiveIcon /></a>
                ):(
                    <RecordDisabledIcon/>
                )}


                {/* <button className='debug' onClick={debug}><DebugIcon/></button> */}


                {localInboundConnectedQueues && localInboundConnectedQueues.length>0?(
                    <div>
                        <p className='queuesTitle'>INBOUND</p>
                        <ul>
                        {localInboundConnectedQueues.map((queue, index) => {
                            return (
                                <li className="rel" tooltip={'Conectado a inbound '+queue.CNY_DETAILS.name+ ', cola '+queue.name} tooltip_class='twoLines' key={index} style={{"color":queue.CNY_DETAILS.color}}>{queue.CNY_DETAILS.code}</li>
                            );
                        })}
                    </ul>
                  </div>
                ):null}
                

                {(incomingCallStatus === 'confirmed' || outgoingCallStatus === 'confirmed') && executiveCallStatus !== 'confirmed' && 
                 JSON.parse(process.env.REACT_APP_CLIENT_REFER_CALLS || '[]').includes(Number(props.selectedCampaign?.company_info._id))?(
                    <a tooltip="Llamar soporte" onClick={() => callExecutive(callExtraHeaders)}><CallExecutive /></a>
                ):null}

                {executiveCallStatus==='confirmed'?(
                    <>
                        <a tooltip="Colgar soporte" onClick={() => hangUpExecutive()}><HangExecutive /></a>
                        <a tooltip="Transferir llamada a soporte" onClick={() => transferClientCallToExecutive(callExtraHeaders)}><TransferIcon /></a>
                    </>
                ) : null}

                
                {/* <AudioRecordingUI/> */}
                <div className="rel center">
                    <a style={{ "anchorName": `--pop-` }} tooltip="Softphone Info" className="popupAnchor" onClick={() => setPopupInfoCallVisible(!popupInfoCallVisible)}><InfoIcon width="30" height="30"/></a>
                    <Popover className="anchored" anchorName={`--pop-`} show={popupInfoCallVisible} width="340px">
                        <dl>
                            <dt>ConnectionStatus</dt><dd className='left'>{softphoneConnectionStatus}</dd>
                            <dt>currentPhone</dt><dd className='left'>{props.currentPhone}</dd>
                            <dt>SessionDirection</dt><dd className='left'>{softphoneSessionDirection}</dd>
                            <dt>incomingCallStatus</dt><dd className='left'>{incomingCallStatus}</dd>
                            <dt>outgoingCallStatus</dt><dd className='left'>{outgoingCallStatus}</dd>
                            <dt>executiveCallStatus</dt><dd className='left'>{executiveCallStatus}</dd>
                            <dt>muted</dt><dd className='left'>{JSON.stringify(muted)}</dd>
                            <dt>holded</dt><dd className='left'>{JSON.stringify(holded)}</dd>
                            <dt>CLIENT_REFER_CALLS</dt><dd className='left'>{process.env.REACT_APP_CLIENT_REFER_CALLS}</dd>
                            <dt>REFER_CALLS_NUMBER</dt><dd className='left'>{process.env.REACT_APP_CLIENT_REFER_CALLS_NUMBER}</dd>
                            <dt>Prefijo campaña</dt><dd className='left'>{props.selectedCampaign?.callPrefix??'600'}</dd>
                            {/* <button onClick={() => unregister()} style={{marginTop:'10px'}}>Unregister</button> */}
                        </dl>
                    </Popover>
                </div>

                
                <div className="rel center">
                    <a style={{ "anchorName": `--pop-` }} tooltip="Llamada externa" className="popupAnchor" onClick={() => setPopupExternalCallVisible(!popupExternalCallVisible)}><ExternalCallIcon width="25" height="25" /></a>
                    <Popover className="anchored" anchorName={`--pop-`} show={popupExternalCallVisible} width="340px">
                        <input type="text" placeholder="Número a llamar" id="externalCallInput" style={{ width: '100%', marginBottom: '10px', padding: '10px 5px' }}/>
                        <button style={{width:'100%', padding: '8px'}} onClick={() => {
                            const number = document.getElementById('externalCallInput').value;
                            if(number){
                                callClient(number, callExtraHeaders);
                                setPopupExternalCallVisible(false);
                            }
                        }}>Llamar</button>
                    </Popover>
                </div>

            </div>
            <div className="edgeBottom"><Edge/></div>
        </div>
    );
    
}

export default SoftphonePanel;
